import { z } from 'zod';

const REQUIRED_MESSAGE = 'Obrigatório';

export const formSchema = z.object({
  cargoIdentifier: z.string({ required_error: REQUIRED_MESSAGE }).min(1, { message: REQUIRED_MESSAGE }),
  driverName: z.string().optional(),
  vehiclePlate: z.string().optional(),
  deadlineDate: z.date({ required_error: REQUIRED_MESSAGE }),
});

export type FormSchema = z.infer<typeof formSchema>